import Basic from './basic.vue';
import MobBasic from '@rebuild/materials/shared/home_wrapper/MobHomeSlide.vue';

export const componentMap = {
	basic: Basic,
	'mob-basic': MobBasic
};
